import {
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Form, Input, Radio, Select } from 'antd';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import {
  UserFormField,
} from 'features/users/components/users-filter-form';
import { useGetRoleTypes } from 'features/users/use-cases/get-roleTypeList';
import { useTranslation } from 'react-i18next';
import { phoneNumberPattern } from 'utils/validations';
const { Option } = Select;
export const UserInfoFormItems = () => {
  const { t } = useTranslation();
  const { data: roleTypeList, isLoading: roleTypeLoading } = useGetRoleTypes();
  if (roleTypeLoading) return null;

  if (!roleTypeList || !Array.isArray(roleTypeList) || roleTypeList.length === 0) {
    return <div>No roles available</div>;
  }

  return (
    <FormSectionsSeparator title={""}>
      <Form.Item<UserFormField>
        label={
          <>
          {t('adminUsers.formFields.name.label')}
           <span style={{ color: 'red', marginLeft: 4 }}>*</span>
          </>
        }
        
        name={UserFormField.FirstName}
        rules={[
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <Input
          placeholder={t('adminUsers.formFields.name.placeholder')}
          prefix={<UserOutlined className='input-prefix-icon' />}
        />
      </Form.Item>


      <Form.Item<UserFormField>
        label={
          <>
          {t('adminUsers.formFields.email.label')}
          <span style={{ color: 'red', marginLeft: 4 }}>*</span>
          </>
        }
        
        
        name={UserFormField.Email}
        rules={[
          {
            required: true,
            whitespace: true,
          },
          {
            type: 'email',
            message: t('validateMessages.custom.email'),
          },
        ]}
      >
        <Input
          placeholder={t('adminUsers.formFields.email.placeholder')}
          prefix={<MailOutlined className='input-prefix-icon' />}

        />
      </Form.Item>

      <Form.Item<UserFormField>
        label={
          <>
          {t('adminUsers.formFields.phoneNumber.label')}
          
          </>
        }
        
        
        name={UserFormField.PhoneNumber}
        rules={[          
          {
            pattern: phoneNumberPattern,
            message: t('validateMessages.custom.phoneNumber'),
          },
        ]}
      >
        <Input
          type='tel'
          placeholder={t('adminUsers.formFields.phoneNumber.placeholder')}
          prefix={<PhoneOutlined className='input-prefix-icon' />}
          autoComplete="off"
          maxLength={15}
          onKeyPress={(e) => {
            // Check if the entered key is a number, "+", or Backspace (to allow deletion)
            const isNumberOrPlus = /^[0-9+]*$/.test(e.key);
            const isBackspace = e.key === 'Backspace';

            // Check if the total length after the new character insertion will be <= 15
            const inputValue = (e.target as HTMLInputElement).value || '';
            const totalLength = inputValue.length + (isBackspace ? -1 : 1);

            if (!isNumberOrPlus || totalLength > 15) {
              e.preventDefault();
            }
          }}
        />
      </Form.Item>


      <Form.Item<UserFormField>
        label={
          <>
          {"Is Active"}
          <span style={{ color: 'red', marginLeft: 4 }}>*</span>
          </>
        }
        
        name={UserFormField.IsActive}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Radio.Group >
          <Radio value={true} > Yes</Radio>
          <Radio value={false}> No </Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item name="role" label={
          <>
          {"Role Type"}
          <span style={{ color: 'red', marginLeft: 4 }}>*</span>
          </>
        }
      
       rules={[{ required: true }]}>
        <Select
          placeholder="Select role type"
          style={{ width: 500 }}
        >
          {roleTypeList && roleTypeList.map((role) => (
            <Option key={role.id} value={role.id}>
              {role.title}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </FormSectionsSeparator>
  );
};
